import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["autoHeight", "children", "connectDragSource", "connectDropTarget", "maxHeight", "maxWidth", "ScrollContainer", "scrollDirection", "scrollElementRef"];
import styled from 'foundations-theming/utils';
import { ScrollOverhang } from '../ScrollOverhang/ScrollOverhang';
import { toPx } from '../../../utils/toPx';
import { jsx as _jsx } from "react/jsx-runtime";
const isHorizontal = direction => direction === 'horizontal' || direction === 'both';
const isVertical = direction => direction === 'vertical' || direction === 'both';
const DefaultScrollContainer = styled.div.withConfig({
  displayName: "ScrollContainer__DefaultScrollContainer",
  componentId: "sc-1ij2j3j-0"
})(["height:", ";width:100%;max-height:", ";max-width:", ";overflow-x:", ";overflow-y:", ";position:relative;"], props => props.$autoHeight ? 'auto' : '100%', props => toPx(props.$maxHeight), props => toPx(props.$maxWidth), props => isHorizontal(props.$scrollDirection) ? 'auto' : 'hidden', props => isVertical(props.$scrollDirection) ? 'auto' : 'hidden');
export const ScrollContainer = _ref => {
  let {
      autoHeight,
      children,
      connectDragSource,
      connectDropTarget,
      maxHeight,
      maxWidth,
      ScrollContainer: _ScrollContainer = DefaultScrollContainer,
      scrollDirection = 'both',
      scrollElementRef
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const refCallback = ref => {
    if (!(scrollElementRef || connectDragSource || connectDropTarget)) return;
    const el = ref;
    if (scrollElementRef) {
      if (typeof scrollElementRef === 'function') {
        scrollElementRef(el);
      } else {
        scrollElementRef.current = el;
      }
    }
    if (connectDragSource) connectDragSource(el);
    if (connectDropTarget) connectDropTarget(el);
  };
  return /*#__PURE__*/_jsx(ScrollOverhang, Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(_ScrollContainer, {
      $autoHeight: autoHeight,
      $maxHeight: maxHeight,
      $maxWidth: maxWidth,
      ref: refCallback,
      $scrollDirection: scrollDirection,
      children: children
    })
  }));
};